import { useContext } from "react";
import WorkspaceContext from "../../WorkspaceContext";
import {
  CARTAZ_GRANDE,
  CARTAZ_MEDIO,
  CARTAZ_PEQUENO,
} from "../EncarteConstants";
import { Measurement, Name, ProductContainer } from "./CartazProduct.styles";
import CartazProductDisplayPrice from "./Cartaz/CartazProductDisplayPrice";
import { truncateWithEllipsis } from "../../../../services/Utils";
import useCanvasProductInteractions from "../../../sharable/EncarteProduct/useCanvasProductInteractions";
import ProductActionBox from "../../../sharable/EncarteProduct/ProductActionBox";

const CARTAZ_NAME_MAX_LENGTH = {
  [CARTAZ_PEQUENO]: 35,
  [CARTAZ_MEDIO]: 40,
  [CARTAZ_GRANDE]: 45,
};

const truncateNameByCartazSize = (name, cartazFormat) => {
  const fallbackMaxLength = CARTAZ_NAME_MAX_LENGTH[CARTAZ_MEDIO];
  const maxLength = CARTAZ_NAME_MAX_LENGTH[cartazFormat] || fallbackMaxLength;
  return truncateWithEllipsis(name, maxLength);
};

export default function CartazProduct({ product, index }) {
  const { canvasScale, styles, products } = useContext(WorkspaceContext);
  const {
    isSelected,
    handleProductClick,
    handleEditClick,
    handleStyleClick,
    handleCloseClick,
  } = useCanvasProductInteractions({
    index,
    isProductClickable: true,
  });

  return (
    <ProductContainer
      canvasScale={canvasScale}
      styles={styles}
      productsLength={products?.length || 1}
      onClick={handleProductClick}
    >
      {isSelected && (
        <ProductActionBox
          onEdit={handleEditClick}
          onStyle={handleStyleClick}
          onClose={handleCloseClick}
        />
      )}
      <Name styles={styles} canvasScale={canvasScale}>
        {truncateNameByCartazSize(
          product.name || "Nome do Produto",
          styles?.format,
        )}
      </Name>

      <Measurement canvasScale={canvasScale}>
        {product.measurement || "UND"}
      </Measurement>

      <CartazProductDisplayPrice
        product={product}
        canvasScale={canvasScale}
        styles={styles}
      />
    </ProductContainer>
  );
}
